import { useCallback, useEffect, useRef, useState } from 'react'
import { debounce } from 'lodash'


export default function useResizeObserver() {
  const
    [size, setSize] = useState({ width: 0, height: 0 }),
    onResize = useCallback((entries) => {
      const entry = entries[0]
      if(!entry) { return }

      const { width, height } = entry.contentRect
      setSize({ width, height })
    }),
    ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if(!element) { return }

    const observer = new ResizeObserver(debounce(onResize, 100, { leading: true }))
    observer.observe(element)

    return () => observer.disconnect()
  }, [])

  return [ref, size]
}
